import React from "react";
import {
    Edit,
    EditProps,
    TitleProps,
    useMutation,
    useRedirect,
} from "react-admin";
import { AdminResource } from "../resource";
import StandardApiError from "shared/errors/standardApiError";
import { UserEditForm } from "reactAdmin/resource/user/userEditForm";
import { useTranslation } from "react-i18next";

const UserTitle = (props: TitleProps) => {
    const { t } = useTranslation();
    return <span>{t('resource.user')} {props.record ? `"${props.record.displayName}"` : ''}</span>;
};

export const UserEdit = (props: EditProps) => {
  const redirect = useRedirect();

  const [mutate] = useMutation();
  const save = React.useCallback(
      async (values, redirectTo) => {
          try {
              await mutate(
                  {
                      type: "update",
                      resource: AdminResource.users,
                      payload: { data: values },
                  },
                  { returnPromise: true }
              );
              redirect(redirectTo, `/${AdminResource.users}`);
          } catch (error) {
              if (error instanceof StandardApiError) {
                  return error.validationErrors;
              }
          }
      },
      [mutate, redirect]
  );

  return (
    <Edit
        title={<UserTitle />}
        {...props}
        mutationMode="pessimistic"
    >
        <UserEditForm save={save} />
    </Edit>
  );
};
